/** App route path constants — kept outside Layout to avoid circular imports. */
export const ROUTES_NAMES = {
  AUTH: "/auth",
  AUTH_INVITACION: "/auth/invitacion",
  AUTH_FORGOT_PASSWORD: "/auth/olvido-contrasena",
  AUTH_RESET_PASSWORD: "/auth/restablecer-contrasena",
  DASHBOARD: "/dashboard",
  CHAT: "/chat",
  /** Home without an id; one route so starting a chat does not remount the page mid-stream. */
  CHAT_THREAD: "/chat/:chatId?",
  /** Former path of the chat; redirects to CHAT keeping the conversation id. */
  LEGACY_INICIO: "/inicio/:chatId?",
  EXPLORAR: "/explorar",
  PODCASTS: "/podcasts",
  PODCAST_DETAIL: "/explorar/podcasts/:slug",
  PODCAST_BRAND_MENTIONS: "/explorar/brands/podcast/:slug",
  MIS_PODCASTS: "/mis-podcasts",
  MI_CONTENIDO: "/mi-contenido",
  /** Must be registered before MI_CONTENIDO_PLATFORM so :platform does not capture these segments. */
  MI_CONTENIDO_PROGRAMA_REPORTES:
    "/mi-contenido/programas/:programId/metricas/reportes",
  MI_CONTENIDO_PROGRAMA_METRICAS: "/mi-contenido/programas/:programId/metricas",
  MI_CONTENIDO_PROGRAMA_CONTENIDO: "/mi-contenido/programas/:programId/contenido",
  MI_CONTENIDO_PROGRAMA_DETAIL: "/mi-contenido/programas/:programId",
  MI_CONTENIDO_MARCA_DETAIL: "/mi-contenido/marcas/:brandKey",
  /** All content for one podcast; must be before MI_CONTENIDO_CANAL_DETAIL is irrelevant — path depth differs. */
  MI_CONTENIDO_PODCAST_REPORTES:
    "/mi-contenido/podcasts/:podcastId/metricas/reportes",
  MI_CONTENIDO_PODCAST_METRICAS: "/mi-contenido/podcasts/:podcastId/metricas",
  MI_CONTENIDO_PODCAST_CONTENIDO: "/mi-contenido/podcasts/:podcastId/contenido",
  MI_CONTENIDO_PODCAST_TOPICS: "/mi-contenido/podcasts/:podcastId/topics",
  MI_CONTENIDO_PODCAST_DETAIL: "/mi-contenido/podcasts/:podcastId",
  MI_CONTENIDO_CANAL_METRICAS:
    "/mi-contenido/podcasts/:podcastId/canales/:socialAccountId/metricas",
  MI_CONTENIDO_CANAL_CONTENIDO:
    "/mi-contenido/podcasts/:podcastId/canales/:socialAccountId/contenido",
  MI_CONTENIDO_CANAL_DETAIL:
    "/mi-contenido/podcasts/:podcastId/canales/:socialAccountId",
  CAMPANAS: "/campanas",
  CAMPANAS_PLATFORM: "/campanas/:campaignId/plataformas/:platform",
  CAMPANAS_CONTENT: "/campanas/:campaignId/contenido",
  CAMPANAS_METRICAS: "/campanas/:campaignId/metricas",
  CAMPANAS_LINKS: "/campanas/:campaignId/enlaces",
  CAMPANAS_DETAIL: "/campanas/:campaignId",
  MI_CONTENIDO_COLECCIONES: "/mi-contenido/colecciones",
  /** Same `CreateCollection` as CREATE_COLLECTION; must be before MI_CONTENIDO_PLATFORM. */
  MI_CONTENIDO_CREAR_COLECCION: "/mi-contenido/crear-coleccion",
  /** Same `GroupDetail` as COLLECTION_DETAIL; must be registered after MI_CONTENIDO_COLECCIONES. */
  MI_CONTENIDO_COLECCION_DETAIL: "/mi-contenido/colecciones/:collectionId",
  /** Must be registered before MI_CONTENIDO_PLATFORM so `media-kits` is not parsed as :platform */
  MI_CONTENIDO_MEDIA_KITS: "/mi-contenido/media-kits",
  MI_CONTENIDO_MEDIA_KIT_DETAIL: "/mi-contenido/media-kits/:podcastId",
  MIS_PODCASTS_MEDIA_KITS: "/mis-podcasts/media-kits",
  MIS_PODCASTS_MEDIA_KIT_DETAIL: "/mis-podcasts/media-kits/:podcastId",
  /** Must be registered before MI_CONTENIDO_PLATFORM so `demo` is not parsed as :platform */
  MI_CONTENIDO_DEMO: "/mi-contenido/demo",
  /** Static collection brand report (screenshot demo); before platform routes. */
  MI_CONTENIDO_DEMO_COLLECTION: "/mi-contenido/demo/coleccion",
  MI_CONTENIDO_PLATFORM: "/mi-contenido/:platform",
  MY_PODCAST_DETAIL: "/mis-podcasts/:slug",
  COLLECTION_DETAIL: "/mis-podcasts/colecciones/:collectionId",
  CREATE_COLLECTION: "/mis-podcasts/crear-coleccion",
  /** Public collection view (all content, no brand filter). URL is /colecciones/:collectionId. */
  MEDIA_KIT: "/colecciones/:collectionId",
  PUBLIC_SPONSOR_LINK: "/colecciones/:collectionId/brands/:brandId",
  PUBLIC_SPONSOR_LINK_LEGACY: "/:slug/:collectionId/brands/:brandId",
  SPONSOR_DETAIL: "/explorar/auspiciadores/:sponsorId",
  SETTINGS: "/settings",
  SETTINGS_PODCAST: "/settings/podcasts/:slug",
  INVITE: "/:companySlug/invitacion/:inviteToken",
  DEV_INVITE_STATES: "/dev/invitacion/estados",
  DEV_METRICS_PDF_PREVIEW: "/dev/metrics-pdf-preview",
  DEV_METRICS_PDF_PREVIEW_WEB: "/dev/metrics-pdf-preview-web",
  ADMIN: "/admin",
  ADMIN_PRIXI_COMPANIES: "/admin/prixi-companies",
  ADMIN_COMPANY_CONFIG: "/admin/companies/:companyId",
  ELECCIONES: "/elecciones",
  PAPI_RICKY: "/papi-ricky",
  TEMP: "/temp",
  BRAND_ANALYSIS: "/marcas",
  PODCAST_ANALYSIS: "/review",
  PODCAST_CONTENT_ANALYSIS: "/review/:podcastId",
  PODCAST_TAXONOMY_TOPICS: "/review/:podcastId/topics",
  CONTENT_TAXONOMY_TOPICS: "/review/content/:contentId/topics",
  PROGRAM_ANALYSIS: "/programs",
  CHANNEL_ANALYSIS: "/admin/channel-analysis",
  ADMIN_PROGRAM_ANALYSIS: "/admin/program-analysis",
  CHANNELS: "/channels",
  CHANNEL_DETAIL: "/channels/:channelId",
  PODCAST_LEARNINGS_EXPLORER: "/admin/podcast-learnings",
  PGM_AUDIT: "/admin/podcast-learnings/pgm-audit",
  PGM_AUDIT_DETAIL: "/admin/podcast-learnings/pgm-audit/:contentId",
  PROGRAM_ANALYSIS_DETAIL: "/programs/:programId",
  PROGRAM_ANALYSIS_VIEWS_ASSET: "/programs/views-asset",
  PROGRAM_ANALYSIS_VIEWS_ASSET_RENDER: "/programs/views-asset-render",
  PROGRAM_ANALYSIS_RANKING_ASSET: "/programs/ranking-asset",
  PROGRAM_ANALYSIS_RANKING_ASSET_RENDER: "/programs/ranking-asset-render",
  PROGRAM_ANALYSIS_LINKEDIN_ASSET_RENDER: "/programs/linkedin-asset-render",
  PROGRAM_ANALYSIS_LIMITED: "/programs-limited",
  BRAND_DETAIL: "/review/brand/:brandId",
  HELP: "/ayuda",
  PRIVACY: "/legal/privacidad",
  TERMS: "/legal/terminos",
  SOCIAL_ADMIN: "/social",
  ADMIN_PIPELINES: "/admin/pipelines",
  ADMIN_PIPELINE_DIGEST_PREVIEW: "/admin/pipeline-digest-preview",
  ADMIN_EMAILING: "/admin/emailing",
  ADMIN_METRICS_REPORTS: "/admin/metrics-reports",
  ADMIN_REVIEW_AUDIT: "/admin/review-audit",
  ADMIN_REVIEW_AUDIT_CASES: "/admin/review-audit/cases",
  ADMIN_CHAT_USAGE: "/admin/chat-usage",
  EXPLORER: "/explorador",
  EXPLORER_PANEL: "/explorador/panel",
  /** Mis programas list. Register static children before :programId. */
  EXPLORER_MIS_PROGRAMAS: "/explorador/mis-programas",
  /** Create followed program (filters only), like crear-colección. */
  EXPLORER_MIS_PROGRAMAS_NUEVO: "/explorador/mis-programas/nuevo",
  /** Edit filters for a followed program. */
  EXPLORER_MIS_PROGRAMAS_EDITAR: "/explorador/mis-programas/:programId/editar",
  /** Feed for one followed program. */
  EXPLORER_FOLLOWED_PROGRAM: "/explorador/mis-programas/:programId",
  EXPLORER_BRANDS_LIST: "/explorador/auspiciadores",
  /** Clips IA: On Demand sponsors list under Auspiciadores. */
  EXPLORER_BRANDS_ONDEMAND: "/explorador/auspiciadores/ondemand",
  /** Clips IA: Clips sponsors list under Auspiciadores. */
  EXPLORER_BRANDS_CLIPS: "/explorador/auspiciadores/clips",
  /** Clips IA Canales hub (top-10 per format + export). */
  EXPLORER_CANALES: "/explorador/canales",
  /** Clips IA: format lists nested under Canales. */
  EXPLORER_CANALES_ONDEMAND: "/explorador/canales/ondemand",
  EXPLORER_CANALES_LIVESTREAMS: "/explorador/canales/livestreams",
  EXPLORER_CANALES_CLIPS: "/explorador/canales/clips",
  /** Clips IA: On Demand program detail under Canales. Register before :podcastId. */
  EXPLORER_CANALES_PROGRAM: "/explorador/canales/ondemand/programs/:programId",
  /** Legacy nested podcast path — redirect to EXPLORER_CANALES_PODCAST. */
  EXPLORER_CANALES_PODCAST_LEGACY: "/explorador/canales/ondemand/podcasts/:podcastId",
  /** Clips IA: On Demand channel (podcast) detail — `/canales/ondemand/:podcastId`. */
  EXPLORER_CANALES_PODCAST: "/explorador/canales/ondemand/:podcastId",
  /** Clips IA: livestream detail tree under Canales. */
  EXPLORER_CANALES_LIVESTREAM_PROGRAM:
    "/explorador/canales/livestreams/program/:programId",
  EXPLORER_CANALES_LIVESTREAM_CHANNEL_PROGRAM:
    "/explorador/canales/livestreams/:channelId/programas/:programId",
  EXPLORER_CANALES_LIVESTREAM_AUDIENCIA: "/explorador/canales/livestreams/audiencia",
  EXPLORER_CANALES_LIVESTREAM_COMPETITION:
    "/explorador/canales/livestreams/rating",
  /** Legacy Spanish slug — redirect to EXPLORER_CANALES_LIVESTREAM_COMPETITION. */
  EXPLORER_CANALES_LIVESTREAM_COMPETITION_LEGACY:
    "/explorador/canales/livestreams/competencia",
  EXPLORER_CANALES_LIVESTREAM_CHANNEL: "/explorador/canales/livestreams/:channelId",
  /** Clips IA: clips channel detail under Canales. */
  EXPLORER_CANALES_CLIPS_CHANNEL: "/explorador/canales/clips/:channelId",
  EXPLORER_PROGRAMS_LIST: "/explorador/programas",
  EXPLORER_SOCIAL_LIST: "/explorador/clips",
  /** Flat (Clips off) clips brand detail. */
  EXPLORER_SOCIAL_BRAND: "/explorador/clips/brands/:brandId",
  /** Clips IA: clips brand detail under Auspiciadores. */
  EXPLORER_BRANDS_CLIPS_DETAIL: "/explorador/auspiciadores/clips/:brandId",
  EXPLORER_SOCIAL_CHANNEL: "/explorador/clips/:channelId",
  EXPLORER_SOCIAL_LIST_LEGACY: "/explorador/social",
  EXPLORER_SOCIAL_CHANNEL_LEGACY: "/explorador/social/:channelId",
  EXPLORER_LIVESTREAMS_LIST: "/explorador/livestreams",
  EXPLORER_PROGRAM: "/explorador/programs/:programId",
  EXPLORER_PODCAST: "/explorador/podcasts/:podcastId",
  /** Livestream program (Explorer) — must be registered before EXPLORER_LIVESTREAM_CHANNEL */
  EXPLORER_LIVESTREAM_PROGRAM: "/explorador/livestreams/program/:programId",
  /** Channel-scoped program — register before EXPLORER_LIVESTREAM_CHANNEL */
  EXPLORER_LIVESTREAM_CHANNEL_PROGRAM:
    "/explorador/livestreams/:channelId/programas/:programId",
  /** Static path before :channelId so "audiencia" is not parsed as an id */
  EXPLORER_LIVESTREAM_AUDIENCIA: "/explorador/livestreams/audiencia",
  /** Static path before :channelId so "rating" is not parsed as an id */
  EXPLORER_LIVESTREAM_COMPETITION: "/explorador/livestreams/rating",
  /** Legacy Spanish slug — redirect to EXPLORER_LIVESTREAM_COMPETITION. */
  EXPLORER_LIVESTREAM_COMPETITION_LEGACY: "/explorador/livestreams/competencia",
  EXPLORER_LIVESTREAM_CHANNEL: "/explorador/livestreams/:channelId",
  EXPLORER_BRAND_MOVERS: "/explorador/brands/movers",
  /** Clips IA: movers under Auspiciadores On Demand. */
  EXPLORER_BRAND_MOVERS_ONDEMAND: "/explorador/auspiciadores/ondemand/movers",
  EXPLORER_BRAND: "/explorador/brands/:brandId",
  /** Clips IA: On Demand brand detail under Auspiciadores. */
  EXPLORER_BRAND_ONDEMAND: "/explorador/auspiciadores/ondemand/:brandId",
  TRACKER: "/tracker",
  TRACKER_PROGRAM: "/tracker/programs/:programId",
  TRACKER_LIVESTREAM_PROGRAM: "/tracker/livestream-programs/:programId",
  TRACKER_CREATOR: "/tracker/:platform/:creatorId",
  TRACKER_YOUTUBE_SHORTS_CREATOR: "/tracker/youtube-shorts/:channelId",
  TRACKER_SHORTFORM_PLATFORM: "/tracker/short-form/:platform",
  TRACKER_SHORTFORM_CONTENT: "/tracker/short-form/content/:contentId",
  BRAND_QUALITATIVE_REPORT: "/reportes/marcas/:brandId",
  TONYBET_EXPLORER_YEAR: "/tonybet",
  TONYBET_EXPLORER_PROGRAM: "/tonybet/programs/:programId",
  TONYBET_EXPLORER_CREATOR: "/tonybet/:platform/:creatorId",
  TONYBET_SHORTFORM_PLATFORM: "/tonybet/short-form/:platform",
  TONYBET_SHORTFORM_CONTENT: "/tonybet/short-form/content/:contentId",
  /** Per-program public media kit: /{company}/{podcast}/{program} */
  PROGRAM_MEDIA_KIT_BY_PATH: "/:companySlug/:podcastSlug/:programSlug",
  PROGRAM_MEDIA_KIT: "/programa/:programSlug/media-kit",
  /** Must be registered before PODCAST_MEDIA_KIT_SHORT so `…/media-kit` is not a podcast slug. */
  COMPANY_MEDIA_KIT_EXAMPLE: "/:companySlug/media-kit",
  PODCAST_MEDIA_KIT: "/:companySlug/:slug/media-kit",
  PODCAST_MEDIA_KIT_SHORT: "/:companySlug/:slug",
  CLIPS: "/clips",
  CLIPS_NUEVA: "/clips/nueva",
  CLIPS_DETAIL: "/clips/:collectionId",
  ROOT: "/",
};
